/** 主要導線を原文と照合したドイツ語表現。自動生成辞書より優先する。 */
export const DE_MANUAL: Record<string, string> = {
  ホーム: "Startseite",
  表示言語: "Anzeigesprache",
  "自動（Shopify）": "Automatisch (Shopify)",
  "発注書・明細": "Bestellungen und Positionen",
  "在庫調整・明細": "Bestandskorrekturen und Positionen",
  "Stockyで Reports → Purchase Orders → CSV を押し、purchase_orders.csvを1つ選びます。次に Purchases から各発注書を開き、Download → CSV で取得した purchase_order_<PO番号>.csvを選びます。Received Only / Not Received Onlyは使いません。個別CSVがない発注書は、明細未取得のまま親一覧と原本を保存できます。":
    "Wählen Sie in Stocky unter Reports → Purchase Orders → CSV eine purchase_orders.csv aus. Öffnen Sie dann jede Bestellung unter Purchases und wählen Sie ihre über Download → CSV exportierte purchase_order_<PO-Nummer>.csv aus. Verwenden Sie weder Received Only noch Not Received Only. Fehlt eine Einzeldatei, können Sie die Übersicht und die Originaldatei auch ohne Positionen speichern.",
  "Stockyで Reports → Adjustments → CSV を押し、stock_adjustments.csvを選びます。期間や拠点を分けて書き出した場合は、取得したCSVをすべて選びます。一般の在庫調整と棚卸し履歴は別データです。":
    "Wählen Sie in Stocky unter Reports → Adjustments → CSV die Datei stock_adjustments.csv aus. Wenn Sie Zeiträume oder Standorte getrennt exportiert haben, wählen Sie alle exportierten CSV-Dateien aus. Allgemeine Bestandskorrekturen und Inventurverläufe sind getrennte Daten.",
  ダッシュボード: "Dashboard",
  注文書: "Einkaufsbestellungen",
  "発注済み・入荷": "Bestellungen und Wareneingang",
  発注点設定: "Meldebestände",
  "季節性の商品別設定": "Saisonale Produkteinstellungen",
  仕入先: "Lieferanten",
  発注元情報: "Firmendaten",
  仕入税率: "Einkaufssteuersätze",
  在庫調整: "Bestandskorrekturen",
  棚卸し: "Inventur",
  拠点間移動: "Umlagerungen",
  セット商品の在庫: "Bestand von Sets",
  在庫分析: "Bestandsanalyse",
  資金繰りカレンダー: "Liquiditätskalender",
  レポート: "Berichte",
  CSV取り込み: "CSV-Import",
  データ: "Daten",
  通知設定: "Benachrichtigungen",
  プラン: "Tarife",
  よくある質問: "Häufige Fragen",
  お問い合わせ: "Kontakt",
  発注: "Einkauf",
  倉庫: "Lager",
  分析: "Auswertung",
  "データ・設定": "Daten und Einstellungen",
  "ストアを確認中": "Shop wird überprüft",
  "ストアを確認中です…": "Shop wird überprüft…",
  "プランを見る": "Tarife ansehen",
  "データ取込を開く": "Datenimport öffnen",
  "Freeでデータ取込を始める": "Datenimport im Free-Tarif starten",
  "有料プランを比較する": "Kostenpflichtige Tarife vergleichen",
  "Free のすべて": "Alles im Free-Tarif",
  無料: "Kostenlos",
  "{days}日間無料で試す": "{days} Tage kostenlos testen",
  "{target} − 在庫 {available} − 入荷予定 {incoming}{ordered} = {raw}{moq}{pack} = {qty}":
    "{target} − Bestand {available} − geplanter Wareneingang {incoming}{ordered} = {raw}{moq}{pack} = {qty}",
  "現在の商品としての確認と、発注設定・仕入条件の反映を同じ操作で行います。異なる現在の設定は上書きしません。{settings} {unchanged}":
    "Mit dieser Aktion bestätigen Sie das aktuelle Produkt und übernehmen die Nachbestelleinstellungen und Lieferantenkonditionen. Abweichende bestehende Einstellungen werden nicht überschrieben. {settings} {unchanged}",
  "無料期間特典が適用されています": "Ihre verlängerte kostenlose Testphase ist aktiviert.",
  "有料プランの変更を確認": "Tarifwechsel bestätigen",
  "同期する": "Synchronisieren",
  "発注数": "Bestellmenge",
  "システム在庫": "Systembestand",
  "CSVダウンロード": "CSV herunterladen",
  "CSVをダウンロード": "CSV herunterladen",
  "PDFをダウンロード": "PDF herunterladen",
  "Chromeウェブストアを開く": "Chrome Web Store öffnen",
  "{label}を編集": "{label} bearbeiten",
  "自動計算": "Automatisch berechnet",
  "自動計算 {point}": "Automatisch berechnet: {point}",
  "自動計算で {point}（日販 {demand} × {days}日分 ＋ 統計的安全在庫 {safety}）":
    "Automatisch berechnet: {point} ({demand}/Tag × {days} Tage + {safety} statistischer Sicherheitsbestand)",
  "自動計算で {point}（日販 {demand} × {days}日分）":
    "Automatisch berechnet: {point} ({demand}/Tag × {days} Tage)",
  "取り消す": "Rückgängig machen",
  "編集": "Bearbeiten",
  "表示する": "Anzeigen",
  "{amount}（目安）": "{amount} (geschätzt)",
  "（目安）": "(geschätzt)",
  "拠点間移動 #{id}": "Umlagerung #{id}",
  "重複: {files}": "Duplikate: {files}",
  "読み取るたびに、その商品の実数が 1 ずつ増えます。読み終えたら「実数を保存」を押してください。":
    "Jeder Scan erhöht die gezählte Menge dieses Produkts um eins. Wählen Sie anschließend „Gezählte Mengen speichern“.",
  "同じセット構成で保存を完了してください":
    "Schließen Sie das Speichern mit derselben Set-Konfiguration ab.",
  "保存済みの送信を確認": "Gespeicherten E-Mail-Versand prüfen",
  "下書きを保存": "Entwurf speichern",
  "「{target}」は現在の商品としてすでに確認済みです。発注設定と仕入条件を確認して反映します。{settings} 現在の設定と異なる場合は何も保存せず停止します。{unchanged} よろしいですか？":
    "„{target}“ wurde bereits als aktuelles Produkt bestätigt. Prüfen und übernehmen Sie die Nachbestelleinstellungen und Lieferantenkonditionen. {settings} Weichen sie von den aktuellen Einstellungen ab, wird nichts gespeichert und der Vorgang beendet. {unchanged} Möchten Sie fortfahren?",
  "保存商品と「{target}」が同じ商品だと確認し、発注設定と仕入条件を確認して反映します。{settings} 現在の設定と異なる場合は何も保存せず停止します。{unchanged} よろしいですか？":
    "Bestätigen Sie, dass das gespeicherte Produkt und „{target}“ dasselbe Produkt sind. Prüfen und übernehmen Sie dann die Nachbestelleinstellungen und Lieferantenkonditionen. {settings} Weichen sie von den aktuellen Einstellungen ab, wird nichts gespeichert und der Vorgang beendet. {unchanged} Möchten Sie fortfahren?",
  "現在の商品としての確認は済んでいます。発注設定と仕入条件を確認して反映します。異なる現在の設定は上書きしません。{settings} {unchanged}":
    "Das aktuelle Produkt wurde bestätigt. Prüfen und übernehmen Sie die Nachbestelleinstellungen und Lieferantenkonditionen. Abweichende bestehende Einstellungen werden nicht überschrieben. {settings} {unchanged}",
  "いつでもアップグレード・ダウングレード・解約できます。":
    "Sie können Ihren Tarif jederzeit wechseln oder kündigen.",
  "編集を破棄して切り替える": "Änderungen verwerfen und wechseln",
  "全員の連携を解除": "Verknüpfung für alle aufheben",
  削除: "Löschen",
  キャンセル: "Abbrechen",
  取消: "Stornieren",
  "棚卸しを中止": "Inventur abbrechen",
  "発注をキャンセル": "Bestellung stornieren",
  "行を削除": "Position entfernen",
  "連携を解除": "Verknüpfung aufheben",
  "季節補正を解除する": "Saisonale Anpassung entfernen",
  "このイベントの適用を解除": "Ereignisanpassung entfernen",
  "現在のプランでは、保存済みの条件の閲覧と削除のみ利用できます。既定の仕入先の条件は発注書に引き続き適用されます。":
    "Mit Ihrem aktuellen Tarif können Sie gespeicherte Einkaufskonditionen nur ansehen und löschen. Die Konditionen des bevorzugten Lieferanten gelten weiterhin für Bestellungen.",
  "今すぐ同期": "Jetzt synchronisieren",
  "未同期": "Noch nicht synchronisiert",
  "同期に失敗しました:": "Synchronisierung fehlgeschlagen:",
  "同期が完了しました。売れ筋とアラートを再計算しました。":
    "Synchronisierung abgeschlossen. Bestseller und Benachrichtigungen wurden neu berechnet.",
  "Shopify の在庫に即時反映されます。よろしいですか？":
    "Diese Änderung wird sofort in Ihrem Shopify-Bestand wirksam. Möchten Sie fortfahren?",
  "この棚卸しを中止します。入力した実数は破棄され、在庫は変更されません。よろしいですか？":
    "Die Inventur wird abgebrochen. Die gezählten Mengen werden verworfen; der Bestand bleibt unverändert. Möchten Sie fortfahren?",
  "この移動を取り消します。まだ出庫していないため在庫は動きません。よろしいですか？":
    "Die Umlagerung wird storniert. Da noch nichts ausgebucht wurde, bleibt der Bestand unverändert. Möchten Sie fortfahren?",
  "在庫数を直接増減・上書きする操作ではありません。販売時にShopifyが原材料在庫を減らします。よろしいですか？":
    "Diese Aktion erhöht, verringert oder überschreibt den Bestand nicht direkt. Beim Verkauf des Sets reduziert Shopify den Bestand der Komponenten. Möchten Sie fortfahren?",
  "「{name}」のUreyukiBox内の旧セット設定（原材料 {n} 件）だけを削除します。Shopifyの商品と作成済みの下書き商品は削除されず、そのまま残ります。この操作は取り消せません。よろしいですか？":
    "Nur die bisherige Set-Konfiguration für „{name}“ in UreyukiBox ({n} Komponenten) wird gelöscht. Das Shopify-Produkt und bereits erstellte Produktentwürfe bleiben erhalten. Diese Aktion kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?",
  "現在は主拠点（{name}）のみの資金繰りカレンダーです。":
    "Der Liquiditätskalender umfasst derzeit nur den Hauptstandort ({name}).",
  "現在は主拠点（{name}）のみの在庫評価額です。":
    "Die Bestandsbewertung umfasst derzeit nur den Hauptstandort ({name}).",
  "現在は主拠点（{name}）のみの発注書です。":
    "Einkaufsbestellungen umfassen derzeit nur den Hauptstandort ({name}).",
};
